import styled from '@emotion/styled';
import { Grid, GridProps } from '@mui/material';

const TableFooter = ({ children, ...rest }: GridProps) => {
  return <Wrapper {...rest}>{children}</Wrapper>;
};

export default TableFooter;

const Wrapper = styled(Grid)`
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  color: ${({ theme }) => theme.palette.default.main};
`;
